import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var applyMoveToCell = function applyMoveToCell(colDef, moveToCell) {
  return _objectSpread(_objectSpread({}, colDef), {}, {
    headerComponentParams: _objectSpread(_objectSpread({}, colDef.headerComponentParams), {}, {
      shouldMoveToCell: true,
      moveToCell: moveToCell
    })
  });
};
export var handleTableKeydown = function handleTableKeydown(_ref) {
  var event = _ref.event,
      columnIndex = _ref.columnIndex,
      gridApi = _ref.gridApi,
      columnApi = _ref.columnApi,
      isTreeTable = _ref.isTreeTable;
  // prevents tabbing into the url section
  event.preventDefault(); // Only need to check row visibility for non-tree tables

  if (!isTreeTable) {
    // scrolls to the first row
    gridApi.ensureIndexVisible(0);
  } // scrolls to the first column


  var column = columnApi.getAllDisplayedColumns()[columnIndex]; // Only need to check column visibility for non-tree tables

  if (!isTreeTable) {
    gridApi.ensureColumnVisible(column);
  } // sets focus into the first grid cell


  gridApi.setFocusedCell(0, column);
};